<template lang="pug">
.document.i_mt_4.i_mt_md_2.i_mt_sm_4
  .main_title.d-flex.align-items-center.i_pb_4
    h4.i_ml_2 {{ honors.Year }}
    svg-icon.d-md-none(
      iconClass="arrow_bottom_g",
      className="arrow_bottom_g",
      :class="{ expand: isExpand }"
    )
    .main_title_btn(@click="expand")
    .main_title_cover
  ul.items.i_pl_10.i_pl_sm_6(, :class="{ expand: isExpand }")
    li.item.d-flex.i_mt_4.i_mt_md_2(v-for="honor in honors.ContentList")
      p.month.flex-shrink-0 {{ honor.Month }}
      p {{ honor.Content }}
</template>

<script>
export default {
  name: "Honor",
  props: {
    honors: Object,
  },
  data() {
    return {
      isExpand: false,
    };
  },
  methods: {
    expand() {
      this.isExpand = !this.isExpand;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/customer_service/document";
li {
  line-height: 35px;
}

.main_title {
  border-bottom: none;
}

.month {
  min-width: 80px;
}

p {
  margin-bottom: 0;
}

@media (max-width: 991px) {
  .month {
    min-width: 50px;
  }

  .main_title {
    h4 {
      font-size: 18px;
    }
  }

  p {
    line-height: 28px;
  }
}

@media (max-width: 767px) {
  .document {
    border-bottom: 1px solid #e8e8e8;
  }

  .main_title {
    h4 {
      font-size: 22px;
    }
  }

  p {
    line-height: 35px;
    font-size: 22px;
  }
}

@media (max-width: 575px) {
  .main_title {
    h4 {
      font-size: 4.2vw;
    }
  }
}
</style>
